import React from 'react';
import { useNavigate } from 'react-router-dom';
import useHttp from '../../hooks/http.hook';
import '../business/Business.css';
import './BannersPage.css';
import CreateBusinessHeader from '../business/components/CreateBusinessHeader';
import CreateFooter from '../business/components/CreateFooter';
import ImageUploadField from '../components/ImageUploadField';

function AddBannerPage() {
  const navigate = useNavigate();
  const { loading, requestWithMeta } = useHttp();

  const [url, setUrl] = React.useState('');
  const [uploadLoading, setUploadLoading] = React.useState(false);
  const [submitError, setSubmitError] = React.useState(null);

  const listPath = '/banners';
  const trimmedUrl = String(url ?? '').trim();
  const isSubmitDisabled = loading || uploadLoading || !trimmedUrl;

  async function handleSubmit() {
    setSubmitError(null);

    if (!trimmedUrl) {
      setSubmitError('Загрузите изображение баннера');
      return;
    }

    const res = await requestWithMeta('/operator/banners', 'POST', { url: trimmedUrl });
    if (!res?.ok) {
      setSubmitError(res?.data?.error || res?.data?.message || 'Не удалось добавить баннер');
      return;
    }

    navigate(listPath, { replace: true });
  }

  return (
    <div className="shop-create-root">
      <div className="shop-create-mobile">
        <CreateBusinessHeader
          title="Новый баннер"
          subtitle="Загрузите изображение для шапки бизнеса"
          onBack={() => navigate(listPath)}
        />

        <main className="shop-create-content add-banner-preview">
          {submitError ? (
            <section className="shop-create-section shop-create-sectionError">
              <div className="shop-create-label">Ошибка</div>
              <div className="shop-create-help shop-create-helpTight">{submitError}</div>
            </section>
          ) : null}

          <ImageUploadField
            label="Изображение"
            help="Рекомендуемый размер: 1800×300 px (широкое фото). Баннер занимает всю ширину экрана, а высота на сайте будет от 100 до 500 px — чем тоньше картинка, тем ниже баннер."
            value={url}
            onChange={setUrl}
            onUploadLoadingChange={setUploadLoading}
            uploadPath="/operator/images?maxDim=1600"
            defaultUrl=""
          />
        </main>

        <CreateFooter
          disabled={isSubmitDisabled}
          label={loading ? 'Сохранение…' : 'Добавить баннер'}
          onCreate={handleSubmit}
        />
      </div>
    </div>
  );
}

export default AddBannerPage;
